import React from 'react';

const ServiceIntro = () => {
    return (
      
            <>
                <section className="service-details">
                    <div className="container">
                       
                           
                                                    <div className="col-md-12 col-lg-10">
                                <div className="service-details__content">
                                
                                    <h2 className="details__lighlight" style={{color:"#F36622", textAlign:"center"}}>Expert Services</h2>
                                    <p className="service-details__text">
                                    We offer comprehensive HR and consulting services tailored to meet the unique needs of businesses of all sizes. At Hillrock Resource Ltd, 
                                    we go beyond traditional HR services by providing access to high-level HR expertise, labor relations management, 
                                    increased efficiency, and on-demand support. Our flexible, tailored, and affordable services are designed to nourish and prosper your organization,
                                     ensuring a complete, compliant, and cost-effective HR support system. 
                                    Let us empower your business to achieve new heights of success.
                                    </p>
                                </div>
                            </div>
                        </div>
                    
                </section>
            </>
       
    );
};

export default ServiceIntro;